var map = {
	"./battles.mp4": 9055,
	"./blackjack.mp4": 8786,
	"./cases.mp4": 1729,
	"./mines.mp4": 1434,
	"./roulette.mp4": 4572,
	"./towers.mp4": 8654,
	"./upgrader.mp4": 3514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9459;